var config = {
  /**
   *  @desc List all the roles you wish to use in the app
   *  You have a max of 31 before the bit shift pushes the accompanying integer out of
   *  the memory footprint for an integer
   */
  roles: ['public', 'user', 'admin'],

  /**
   *  @desc Build out all the access levels you want referencing the roles listed above
   *  You can use the "*" symbol to represent access to all roles.

   *  The left-hand side specifies the name of the access level, and the right-hand side
   *  specifies what user roles have access to that access level. E.g. users with user role
   *  'user' and 'admin' have access to the access level 'user'.
   */
  accessLevels: {
    public: '*',
    anon: ['public'],
    user: ['user', 'admin'],
    admin: ['admin'],
  },
};
var routingConfig = {};

/**
 *  @desc Method to build a distinct bit mask for each role
 *  It starts off with "1" and shifts the bit to the left for each element in the
 *  roles array parameter
 */

(function() {
  var roles = config.roles;
  var bitMask = '01';
  var userRoles = {};

  for (var role in roles) {
    if (roles.hasOwnProperty(role)) {
      var intCode = parseInt(bitMask, 2);
      userRoles[roles[role]] = {
        bitMask: intCode,
        title: roles[role],
      };
      /*jslint bitwise: true */
      bitMask = (intCode << 1).toString(2);
    }
  }
  routingConfig.userRoles = userRoles;
})();

/**
 *  @desc This method builds access level bit masks based on the accessLevelDeclaration parameter which must
 *  contain an array for each access level containing the allowed user roles.
 */
(function() {
  var accessLevelDeclarations = config.accessLevels;
  var userRoles = routingConfig.userRoles;
  var accessLevels = {};
  var resultBitMask;
  for (var level in accessLevelDeclarations) {
    if (typeof accessLevelDeclarations[level] === 'string') {
      if (accessLevelDeclarations[level] === '*') {
        resultBitMask = '';

        for (var role in userRoles) {
          if (userRoles.hasOwnProperty(role)) {
            resultBitMask += '1';
          }
        }
        accessLevels[level] = {
          bitMask: parseInt(resultBitMask, 2),
        };
      } else {
        Logger.error(
          'Access Control Error: Could not parse "' +
            accessLevelDeclarations[level] +
            '" as access definition for level "' +
            level +
            '"',
        );
      }
    } else {
      resultBitMask = 0;
      for (var nRole in accessLevelDeclarations[level]) {
        if (userRoles.hasOwnProperty(accessLevelDeclarations[level][nRole])) {
          /*jslint bitwise: true */
          resultBitMask = resultBitMask | userRoles[accessLevelDeclarations[level][nRole]].bitMask;
        } else {
          Logger.error(
            'Access Control Error: Could not find role "' +
              accessLevelDeclarations[level][nRole] +
              '" in registered roles while building access for "' +
              level +
              '"',
          );
        }
      }
      accessLevels[level] = {
        bitMask: resultBitMask,
      };
    }
  }
  routingConfig.accessLevels = accessLevels;
})();

export default routingConfig;
